import { handle } from 'redux-pack';
import dayjs from 'dayjs';

export const mapFetchedProfile = (payload) => ({
  id: payload.id,
  name: {
    value: payload.name,
    valid: false,
    validated: false,
  },
  phoneNumber: payload.phoneNumberView || '',
  email: payload.email || '',
  alternativeEmail: {
    value: payload.alternativeEmail || '',
    valid: false,
    validated: false,
  },
  birthDate: {
    value: dayjs(payload.birthDate, 'DD/MM/YYYY').format('MM/DD/YYYY') || '',
    valid: false,
    validated: false,
  },
  acceptWhatsapp: {
    value: payload.acceptWhatsapp !== false, // fallback for undefined: true
  },
  acceptSms: {
    value: payload.acceptSms !== false, // fallback for undefined: true
  },
  hashId: payload.hashId,
});

export const handleFetchProfile = (state, action) => handle(state, action, {
  success: (prevState) => ({
    ...prevState,
    updatedProfile: mapFetchedProfile(action.payload),
  }),
});

export const handleSetFieldValue = (state, action) => {
  // eslint-disable-next-line no-param-reassign
  state.updatedProfile[action.key].value = action.value;
};

export const handleSaveProfile = (state, action) => handle(state, action, {
  start: (prevState) => ({
    ...prevState,
    loaded: false,
    error: false,
    isSubmitting: true,
  }),
  success: (prevState) => ({
    ...prevState,
    loaded: true,
    error: false,
  }),
  failure: (prevState) => ({
    ...prevState,
    loaded: true,
    error: true,
  }),
  finish: (prevState) => ({
    ...prevState,
    isSubmitting: false,
  }),
});

export const handleSetFieldValid = (state, action) => {
  // eslint-disable-next-line no-param-reassign
  state.updatedProfile[action.key].valid = action.valid;
  // eslint-disable-next-line no-param-reassign
  state.updatedProfile[action.key].validated = true;
  return state;
};

export const handleDismissSnackbar = (state) =>
  ({
    ...state,
    loaded: false,
  });
